import React from 'react'
import Address from '../../components/Company/Address'
import URLS from '../../config/URLS'
import { Link } from '@abw/badger-ui'
import { Helmet } from 'react-helmet-async'
import { HelpEmail, Telephone1, Telephone2 } from '../../config/Site'

export const Contact = () =>
  <>
    <Helmet>
      <title>LFH - Contact Us</title>
    </Helmet>
    <div className="darkside about">
      <h1 className="mar-t-none mar-b">Contact us</h1>
      <Section icon="phone" title="Speak to us">
        <h3 className="mar-l-4">
          <a href={`tel:${Telephone1}`}>{Telephone1}</a>
          <span className="small mar-h">or</span>
          <a href={`tel:${Telephone2}`}>{Telephone2}</a>
        </h3>
        <p>
          If you need to speak to somebody, you can call us on either of
          the numbers above. Our phone lines are open Monday to Friday 9:30am
          to 4pm, however we can reply to emails and voicemails up to 5:30pm.
          We're closed at weekends and Bank Holidays.
        </p>
      </Section>
      <Section icon="at-sign" title="Write to us" className="mar-t-2">
        <h3 className="mar-l-4"><a href={`mailto:${HelpEmail}`} className="yellow">{HelpEmail}</a></h3>
        <p>
          You can always contact us by email at: {' '}
          <a href={`mailto:${HelpEmail}`}>{HelpEmail}</a>.
          We can sometimes respond to emails when the office is closed.
        </p>
      </Section>
      <Section icon="gift" title="Send us stuff" className="mar-t-2">
        <p>
          If you want to send us bouquets and/or cakes (chocolate is our
          favourite), or something like a lens hood which you found in the
          bottom of your camera bag, the address is:
        </p>
        <Address/>
        <p>
          That's also the address you need to use when sending lenses back to us.
        </p>
      </Section>
      <Section icon="carry" title="Collect the equipment you're hiring" className="mar-t-2">
        <p>
          For further information about collecting equipment from us,{' '}
          <Link to={URLS.about.collect} text="click here"/>.
        </p>
      </Section>
      <Section icon="carry flip-h" title="Return the equipment you've hired" className="mar-t-2">
        <p>
          For further information about returning equipment to us,{' '}
          <Link to={URLS.about.return} text="click here"/>.
        </p>
      </Section>
      <Section icon="gavel" title="Legal stuff" className="mar-t-2">
        <p>
          Details of our registered office and VAT number can be{' '}
          <Link to={URLS.about.legal} text="found here"/>.
        </p>
      </Section>
    </div>
  </>

export const Section = ({title, children}) =>
  <section>
    <h3 className="section-title">{title}</h3>
    {children}
  </section>

export default Contact